import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { AdminHeader } from "../header";
import Footer from "../../footer";
import {getStudentIdData} from "../../../lib/studentgoalgrades";
import {getStudentIdData as getStudentGoalQuestions } from "../../../lib/studentgoalquestionview"
import {getStudentIdData as getStudentColleges} from "../../../lib/studentcollegelistview"
import { getDataWithTypeForSelect } from "../../../lib/parameters"
import { useParams ,useNavigate} from 'react-router-dom';
import StudentInfoBox from "../studentGrid/studentinfobox";

const TYPES = { 
  'GPA': 'GPA',
  'AP': 'AP',
  'Honor': 'Honor',
  'SatRw' : 'SatRw',
  'SatMath' : 'SatMath',
  'DualEn' : 'DualEn',
  'SummerC':'SummerC'
}

const AdminStudentProfile = () => {
  
  const [studentInfo, setStudentInfo] = useState([]);
  const [questionlist, setQuestionlist] = useState([]);
  const [collegelist, setCollegeList] = useState([]);
  const [parameters, setParameters] = useState([]);
  const navigate = useNavigate();
  let { slug } = useParams();
  //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";

  async function GetData() {
    const info = await getStudentIdData(slug);
    setStudentInfo(info);
    const questions = await getStudentGoalQuestions(slug);
    setQuestionlist(questions);

    const colleges = await getStudentColleges(slug);
    setCollegeList(colleges);

    const parameterData = await getDataWithTypeForSelect("DESIRED_COLLEGES");
    setParameters(parameterData);
    console.log("colleges",colleges);
  }

  function getRank(ranks,key) {
    //console.log("ranks",JSON.parse(ranks), key);

    const result = Object.entries(JSON.parse(ranks)).filter(item => item[0] === key.toString() )
    //console.log("result",result);
      return result[0][1];
  }

  useEffect(() => {
    GetData();
  }, [])

  return (
    <>
      <div className="main-wrapper">
       <AdminHeader activeMenu={""}/>


        <section className="course-content">
          <div className="container">
          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm mb-2">
                          {"<< Back"}
                          </button>
                          
            <div className="card wish-card">
              <div className="card-header">
                
                <StudentInfoBox slug={slug} />
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                  <h5>Student Profile</h5>
                    <div className="wishlist-item mt-5">
                      <div className="row table-responsive">
                        <table className="table table-striped mb-0 table-hover">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col"></th>
                                  <th scope="col">School</th>
                                  <th scope="col">College</th>
                                  <th scope="col">Student</th>
                                  <th scope="col">Goal</th>
                                  <th scope="col">Goal - Existing</th>
                                </tr>
                              </thead>
                              <tbody>
                              {studentInfo ? studentInfo.map(function (data) {
                          return (
                                <tr key = {data.id}>
                             
                                <th scope="row">{data.type}</th>
                                <td></td>
                                  <td>{data.schoolGrade}</td>
                                  <td>{data.collegeGrade}</td>
                                  <td>{data.currentGrade}</td>
                                  <td>{data.goalGrade}</td>
                                  <td>{data.goalGrade - data.currentGrade}</td>
                                </tr>
                                 )
                                })  : ""}
                              </tbody>
                            </table>
                      </div>
                    </div>
                    <div className="wishlist-item mt-5">
                      <div className="row align-items-center">
                      <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th>Question</th>
                                <th>Answer</th>
                              </tr>
                            </thead>
                            <tbody>
                            {questionlist.map(function (data) {
                              return (
                                <tr key={data.questionId}>
                                <td>{data.pname}</td>
                                <td>{data.studentAnswer}</td>
                              </tr>
                              )
                            })}
                            </tbody>
                          </table>
                      </div>
                    </div>
                    <div className="wishlist-item mt-5">
                      <div className="row align-items-center">
                      <table className="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>List of desired colleges</th>
                            <th></th>
                            {collegelist ? collegelist.map(function (clist)
                            {
                              return (
                                <th key={clist.id}>{clist.collegename}</th>
                              )
                            }): <th></th>
                          }
                          </tr>
                        </thead>
                        <tbody>
                        {parameters ? parameters.map(function (prm) {
                          return (
                            <tr key={prm.value}>
                            <td>{prm.label}</td>
                            <td></td>
                            
                            {collegelist ? collegelist.map(function (c2list)
                            {
                              return (
                                <td key={c2list.id}>{getRank(c2list.rankvalue, prm.value)}</td>
                              )
                            }): <td></td>
                          }
                          </tr>
                          )
                        }) : ""}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Plan Type */}
              </div>
            </div>
          </div>
        </section>

        <Footer/>
      </div>
    </>
  );
};

export default AdminStudentProfile;
